<template>
    <div class="table-body">
        <slot></slot>

        <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
            <div slot="spinner" class="loader-wrapper">
                <img src="imgs/vitadio-loader.svg" alt="">
            </div>
            <div slot="no-more">
                <!--<p>{{ __('Žádné další výsledky') }}</p>-->
            </div>

            <div slot="no-results" class="no-patients">
                <figure>
                    <SvgIcon icon="icon-no-patients" />
                </figure>
                <p>{{ __('You have no patients in this section yet') }}</p>
            </div>
        </infinite-loading>
    </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading'

export default {
    components: {
        InfiniteLoading
    },
    props: {
        params: {
            type: Object,
            required: true
        },
        phase: {
            type: String,
            required: false
        },
        freemium: {
            type: Number,
            required: false,
            default: 0
        },
        freeze: {
            type: Number,
            required: false,
            default: 0
        },
        deactivated: {
            type: Number,
            required: false,
            default: 0
        }
    },
    data() {
        return {
            infiniteId: +new Date(),
            page: 1,
            fetchTimeout: -1,
            cancelTokenSource: axios.CancelToken.source()
        }
    },
    computed: {
        requestParams() {
            if(this.user.role === 'coach_admin' || this.phase === 'unassigned_onboarding') {
                return {
                    ...this.params,
                    page: this.page
                }
            } else {
                return {
                    ...this.params,
                    page: this.page,
                    phase: this.phase,
                    freemium: this.freemium,
                    freeze: this.freeze,
                    deactivated: this.deactivated
                }
            }
        },
        url() {
            if(this.user.role === 'coach_admin') {
                return '/coach_admin/patients/' + this.phase
            } else {
                if(this.user.role === 'coach') {
                    return '/coaches/patients'
                } else {
                    if(this.phase === 'unassigned_onboarding') {
                        return '/doctor/patients/' + this.phase
                    }

                    return '/doctors/patients/'
                }
            }
        }
    },
    beforeDestroy() {
        this.cancelRequest()
    },
    methods: {
        infiniteHandler($state) {
            this.cancelRequest()

            this.cancelTokenSource = axios.CancelToken.source()

            this.fetchTimeout = setTimeout(() => {
                axios
                    .get(this.url, {
                        params: this.requestParams,
                        cancelToken: this.cancelTokenSource.token
                    })
                    .then(({ data }) => {
                        var patients = data

                        if(this.user.role === 'coach_admin' || (this.user.role === 'doctor' && this.phase === 'unassigned_onboarding')) {
                            if(this.phase === 'inactive_in_app' || this.phase === 'inactive_connected' || this.phase === 'unassigned_onboarding') {
                                patients = data.data
                            } else {
                                patients = Object.keys(data.data.data).map(i => data.data.data[i]);
                            }
                        }

                        this.afterFetchRequest($state, patients)
                    })
                    .catch((e) => {
                        console.log(e.response)
                    })
            }, 350)
        },
        cancelRequest() {
            this.cancelTokenSource.cancel()
            clearTimeout(this.fetchTimeout)
        },
        afterFetchRequest($state, data) {            
            if (data.length) {
                this.processFetchedData($state, data)
            } else {
                $state.complete()
                Vuemit.fire('PatientsMatrix--fetched')
            }

            Vuemit.fire('PatientsMatrix--fetched')
        },
        processFetchedData($state, data) {
            this.page += 1

            this.$emit('fetched', data)

            $state.loaded()

            if (data.length < 10) {
                $state.complete()
            }
        },
        reset() {
            this.infiniteId += 1
            this.page = 1
        }
    }
}
</script>
